import { type Faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-react';
import escapeRegExp from 'lodash/escapeRegExp';
import isNil from 'lodash/isNil';

const faroCollectorUrl = import.meta.env.VITE_FARO_COLLECTOR_URL;

// Build an ignore-pattern for the PostHog host so Faro's fetch instrumentation doesn't
// capture PostHog telemetry calls as events. Derived from VITE_POSTHOG_HOST so that
// self-hosted PostHog instances are covered too.
const posthogIgnorePatterns: RegExp[] = (() => {
  const posthogHost = import.meta.env.VITE_POSTHOG_HOST;
  if (isNil(posthogHost)) return [];
  try {
    const { host } = new URL(posthogHost);
    return [new RegExp(escapeRegExp(host))];
  } catch {
    return [];
  }
})();

export let faro: Faro | null = null;

if (!isNil(faroCollectorUrl)) {
  faro = initializeFaro({
    url: faroCollectorUrl,
    app: {
      name: import.meta.env.VITE_FARO_APP_NAME || 'Predium',
      version: import.meta.env.VITE_COMMIT_HASH || 'dev',
      environment: import.meta.env.VITE_ENV || 'development',
    },
    // Router instrumentation is handled by withFaroRouterInstrumentation in index.tsx.
    // ReactIntegration (FaroErrorBoundary, withFaroProfiler) is intentionally not registered — we
    // already have branded, i18n error boundaries that pushError to Faro, and nothing consumes the profiler.
    instrumentations: [...getWebInstrumentations()],
    ignoreErrors: [
      // Layout quirks - harmless, not real errors
      /^ResizeObserver loop limit exceeded$/,
      /^ResizeObserver loop completed with undelivered notifications$/,
      // Cross-origin scripts with no useful stack
      /^Script error\.$/,
      // Browser extension interference
      /chrome-extension:\/\//,
      /moz-extension:\/\//,
    ],
    ignoreUrls: posthogIgnorePatterns,
  });
}
